import { getStoredProfile } from '@/utils/auth'

const parsePositiveNumber = (value, fallback = 0) => {
  const parsed = Number(value)

  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

export const API_BASE_URL = 'https://course.sanzhicangshu.com' || process.env.VUE_APP_API_BASE_URL || ''
export const DEFAULT_SITE_ID = parsePositiveNumber(process.env.VUE_APP_SITE_ID, 1)
export const DEFAULT_SHOP_ID = parsePositiveNumber(process.env.VUE_APP_SHOP_ID, 1)
export const DEFAULT_APP_ID = parsePositiveNumber(process.env.VUE_APP_APP_ID, 1)
export const TENCENT_CLOUD_PLAYER_LICENSE_URL = process.env.VUE_APP_TCPLAYER_LICENSE_URL || 'https://1322704663.trtcube-license.cn/license/v2/1322704663_1/v_cube.license'
export const TENCENT_CLOUD_PLAYER_LICENSE_KEY = process.env.VUE_APP_TCPLAYER_LICENSE_KEY || '53805f638f02c5a49cd58493a4aa331f'

export const withAppContext = (payload = {}) => {
  const contextPayload = {
    ...payload
  }

  if (DEFAULT_SHOP_ID && typeof contextPayload.shop_id === 'undefined') {
    contextPayload.shop_id = DEFAULT_SHOP_ID
  }

  if (DEFAULT_APP_ID && typeof contextPayload.app_id === 'undefined') {
    contextPayload.app_id = DEFAULT_APP_ID
  }

  return contextPayload
}

export const withMemberContext = (payload = {}) => {
  const contextPayload = withAppContext(payload)

  if (typeof contextPayload.mid === 'undefined') {
    const profile = getStoredProfile() || {}
    const memberId = parsePositiveNumber(profile.id || profile.member_id || profile.mid, 0)

    if (memberId) {
      contextPayload.mid = memberId
    }
  }

  return contextPayload
}

export const withHomeContext = (payload = {}) =>
  withAppContext({
    site_id: DEFAULT_SITE_ID,
    ...payload
  })
